import React, { useState, useEffect } from 'react'
import "./tooltip.css";
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
// import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
// import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
// import CustomImage from '../../../UIComponents/CustomImage';
// import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
// import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
// import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { postAPI, postAPIForm, getURL, formatDate, convertTo12Hour, splitISODateTime } from '../../../app/api';
import { store } from '../../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import SendEmailForm from './SendEmailForm';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({PopupID="", setIsEdit, setEditId}) {
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canSendEmail, setCanSendEmail] = useState(false);
    const [canAllocate, setCanAllocate] = useState(false);
    const [canExport, setCanExport] = useState(false);
    
    // Video Player Modal States
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videosList, setVideosList] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [videoLoading, setVideoLoading] = useState(false);
    const [videoError, setVideoError] = useState(null);

    // Helper function to format duration from array length (seconds to human readable)
    const formatDuration = (eyeMovementArray) => {
        if (!eyeMovementArray || eyeMovementArray.length === 0) return 'N/A';
        
        const totalSeconds = eyeMovementArray.length;
        
        if (totalSeconds < 60) {
            return `${totalSeconds} second${totalSeconds !== 1 ? 's' : ''}`;
        } else if (totalSeconds < 3600) {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${minutes}min ${seconds}sec`;
        } else {
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            return `${hours}h ${minutes}m`;
        }
    };

    // Helper function to parse eye movement response and get statistics
    const getEyeMovementStats = (eyeMovementData) => {
        if (!eyeMovementData) return { total: 0, breakdown: {}, duration: 'N/A' };
        
        let data = eyeMovementData;
        if (typeof eyeMovementData === 'string') {
            try {
                data = JSON.parse(eyeMovementData);
            } catch (e) {
                return { total: 0, breakdown: {}, duration: 'N/A' };
            }
        }

        const breakdown = {};
        data.forEach(item => {
            breakdown[item] = (breakdown[item] || 0) + 1;
        });

        return {
            total: data.length,
            breakdown: breakdown,
            duration: formatDuration(data)
        };
    };

    // Tooltip action handlers for Edit and Delete
    const handleEdit = (val) => {
        // TODO: Implement edit logic
        alert('Edit action for: ' + (val?.participant_name || ''));
    };
    const handleDelete = (val) => {
        // TODO: Implement delete logic
        alert('Delete action for: ' + (val?.participant_name || ''));
    };

    // Video Player Handler
    const handleViewRecording = async (val) => {
        setShowVideoModal(true);
        setVideoLoading(true);
        setVideoError(null);
        setVideosList([]);
        setSelectedVideo(null);
        
        try {
            const filter = {
                exam_id: val?.exam_id,
                user_unique_id: val?.user_unique_id,
                org_id: store_data?.org_id
            };
            
            const response = await postAPI("/exam-videos/get-video-by-user-exam", filter);
            
            if (response?.status === 1) {
                setVideosList(response?.data);
                // Auto-select first video
                setSelectedVideo(response?.data[0]);
                setVideoLoading(false);
            } else {
                setVideoError(response?.error || 'No videos found for this user');
                setVideosList([]);
                setSelectedVideo(null);
                setVideoLoading(false);
            }
        } catch (error) {
            setVideoError('Error loading videos: ' + error.message);
            setVideosList([]);
            setSelectedVideo(null);
            setVideoLoading(false);
        }
    };

    const handleCloseVideoModal = () => {
        setShowVideoModal(false);
        setVideosList([]);
        setSelectedVideo(null);
        setVideoError(null);
    };

    const handleSelectVideo = (video) => {
        setSelectedVideo(video);
    };

    const {exam_id} = useParams();
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [ParticipantsData, setParticipantsData] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchParticipantsData = async () => {
        const filter = { id: store_data?.org_id, exam_id: exam_id }
        const response = await postAPI("/participants/rank-list", filter);
        if (response?.status) {
            setParticipantsData(response?.data)
            setLoading(false)
        } else {
            setParticipantsData([])
            setLoading(false)
        }
    }

    const handleChangeStatus = async (id, status) => {
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/participants/toggle-status", filter);
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/participants/remove", filter);
        if (response?.status == 1) {
            toast.success('Additional charges removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const generateInvoice = async (user_unique_id, exam_id_) => {
        const filter = { org_id: store_data?.org_id, user_unique_id: user_unique_id, exam_id: exam_id_ }
        const response = await postAPI("/pdf/create-payslip", filter);
        // const response = await postAPI("/pdf/create-payslip", filter);
        if (response?.status == 1) {
            // toast.success('Additional charges removed successfully.');
            // window.location.reload()
        } else {
            // toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanSendEmail(true);
                setCanAllocate(true);
                fetchParticipantsData();
            } else {
                const viewAllowed = await hasPermission("REWARDS", "RewardAllotment", "VIEW");
                const emailAllowed = await hasPermission("REWARDS", "RewardAllotment", "SEND_EMAIL");
                const allocateAllowed = await hasPermission("REWARDS", "RewardAllotment", "ALLOCATE");
                
                setCanView(viewAllowed);
                setCanSendEmail(emailAllowed);
                setCanAllocate(allocateAllowed);
                
                if (viewAllowed) {
                    fetchParticipantsData();
                }
            }
        };
        checkPermissions();
    }, [])
    return (
        <>
            <table class="table card-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Exam Details</th>
                        <th>Discount & Charges</th>
                        <th>Paid Amt</th>
                        <th>Rank</th>
                        <th>Reward</th>
                        <th>Claimed ?</th>
                    </tr>
                </thead>
                <tbody class="table-border-bottom-0">
                    <tr>
                        <td colSpan={7} className='text-center'> Total { ParticipantsData.length } Participants Found. </td>
                    </tr>
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="7" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : ParticipantsData && ParticipantsData?.length > 0 ?
                            ParticipantsData?.map((val, index) => (
                                <tr>
                                    <td>
                                        {val?.participant_name}
                                        <br />
                                        <a href={`tel:${val?.participant_phone}`}>{val?.participant_phone}</a>
                                        <br />
                                        <a href={`mailto:${val?.participant_email}`}>{val?.participant_email}</a>
                                        <br />
                                        {/* <small>( {val?.user_unique_id} )</small> */}
                                    </td>
                                    <td>
                                        <p>Enroll Date: <br />
                                        {formatDate((splitISODateTime(val?.enrollment_date)[0]))?.month} {formatDate((splitISODateTime(val?.enrollment_date)[0]))?.day}, {formatDate((splitISODateTime(val?.enrollment_date)[0]))?.year} {convertTo12Hour((splitISODateTime(val?.enrollment_date)[1]))}
                                        </p>
                                        <p>Exam: {val?.exam_title}</p>
                                        <p>Fee: ₹{parseFloat(val?.enrollment_fee).toFixed(2)}</p>
                                    </td>
                                    <td>
                                        <p>
                                            Discount: ₹{parseFloat(val?.discount_amount).toFixed(2)}
                                            <br />
                                            <small>( Coupon Applied: {val?.coupon_code || 'N/A'} )</small>
                                        </p>
                                        <p>
                                            Tax: ₹{parseFloat(val?.tax_amount).toFixed(2)}
                                        </p>
                                        <p>
                                            Total Additional Charge: <br />
                                            ₹{parseFloat(val?.additional_charge_amount).toFixed(2)}
                                        </p>
                                    </td>
                                    <td>₹{parseFloat(val?.final_payable_amount).toFixed(2)}</td>
                                    <td>{val?.user_rank}</td>
                                    <td>{val?.reward}</td>
                                    <td>{val?.is_reward_claimed ? 'Yes ✓' : 'No ✗'}</td>
                                    {/* <td>
                                        <span className="tooltip" onClick={() => generateInvoice(val?.user_unique_id, val?.exam_id)}>
                                            <span className="badge bg-label-danger me-1 cursor-pointer">
                                                <i className="fa fa-file-pdf"></i>
                                            </span>
                                            <span className="tooltiptext">Check Invoice</span>
                                        </span>
                                        <span className="tooltip" onClick={() => handleViewRecording(val)}>
                                            <span className="badge bg-label-danger me-1 cursor-pointer">
                                                <i className="fa fa-video"></i>
                                            </span>
                                            <span className="tooltiptext">View Recording</span>
                                        </span>
                                        <span className="tooltip">
                                            <span className="badge bg-label-success me-1 cursor-pointer">
                                                <i className="fa fa-check"></i>
                                            </span>
                                            <span className="tooltiptext">Confirm Payment</span>
                                        </span>
                                        <span className="tooltip">
                                            <i className="fa fa-edit" onClick={() => handleEdit(val)}></i>
                                            <span className="tooltiptext">Edit</span>
                                        </span>
                                        <span className="tooltip">
                                            <i className="fa fa-trash" onClick={() => handleDelete(val)}></i>
                                            <span className="tooltiptext">Delete</span>
                                        </span>
                                    </td> */}
                                    {/* <td>₹{parseFloat(val?.final_payable_amount).toFixed(2)}</td> */}
                                    {/* <td><span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>{val?.status === 1 ? 'Active' : 'Inactive'}</span></td>
                                    <td>
                                        <span className="badge bg-label-primary me-1" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(true);setEditId(val?.id);}}><i className="fa fa-pen"></i></span>
                                        <span className="badge bg-label-danger me-1 cursor-pointer"
                                        onClick={() => {
                                            if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                handleRemove(val?.id);
                                            } else {
                                                console.log("Remove cancelled.");
                                            }
                                        }}
                                        ><i className="fa fa-trash"></i></span>
                                    </td> */}
                                </tr>
                            ))
                            : ''
                    }
                </tbody>
            </table>
            
            {/* Video Player Modal */}
            {showVideoModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                    <div className="modal-dialog modal-xl" style={{ maxWidth: '1200px' }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Exam Recordings ({videosList.length})</h5>
                                <button type="button" className="btn-close" onClick={handleCloseVideoModal}></button>
                            </div>
                            <div className="modal-body">
                                {videoLoading ? (
                                    <div className="text-center py-5">
                                        <Loader />
                                        <p className="mt-3">Loading videos...</p>
                                    </div>
                                ) : videoError ? (
                                    <div className="alert alert-danger" role="alert">
                                        <i className="fa fa-exclamation-circle me-2"></i>
                                        {videoError}
                                    </div>
                                ) : videosList && videosList.length > 0 ? (
                                    <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: '20px' }}>
                                        {/* Video List Sidebar */}
                                        <div className="card card-body" style={{ 
                                            maxHeight: '600px',
                                            overflowY: 'auto',
                                            padding: '0.75rem'
                                        }}>
                                            <h6 className="mb-2" style={{ fontWeight: 600 }}>
                                                <i className="fa fa-list me-2"></i>
                                                Select Video
                                            </h6>
                                            {videosList.map((video, idx) => (
                                                <div
                                                    key={idx}
                                                    onClick={() => handleSelectVideo(video)}
                                                    className={`card cursor-pointer mb-2 ${selectedVideo?.id === video.id ? 'bg-label-primary border-primary' : ''}`}
                                                    style={{
                                                        padding: '0.75rem',
                                                        transition: 'all 0.3s ease',
                                                        borderWidth: selectedVideo?.id === video.id ? '2px' : '1px'
                                                    }}
                                                >
                                                    <p className="mb-1 fw-bold" style={{ fontSize: '12px' }}>
                                                        Video {idx + 1}
                                                    </p>
                                                    <small className="text-muted d-block">
                                                        {video.recordtime ? new Date(video.recordtime).toLocaleString() : 'N/A'}
                                                    </small>
                                                    <small className="mt-1 d-inline-block">
                                                        <span className={`badge ${video.is_face_verified ? 'bg-success' : 'bg-danger'}`}>
                                                            {video.is_face_verified ? 'Face OK' : 'No Face'}
                                                        </span>
                                                    </small>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Video Player Section */}
                                        {selectedVideo && (
                                            <div className="video-player-container">
                                                <video 
                                                    width="100%" 
                                                    height="400" 
                                                    controls 
                                                    controlsList="nodownload"
                                                    style={{ borderRadius: '8px', backgroundColor: '#000', marginBottom: '16px' }}
                                                >
                                                    <source src={selectedVideo?.video_url} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>

                                                {/* Video Statistics */}
                                                <div className="card card-body">
                                                    <h6 className="mb-3 fw-bold">
                                                        <i className="fa fa-info-circle me-2"></i>
                                                        Video Statistics
                                                    </h6>
                                                    
                                                    {/* Basic Info */}
                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                                                        <div className="card card-body p-2">
                                                            <strong className="text-muted d-block" style={{ fontSize: '12px' }}>Recording Time</strong>
                                                            <p className="mb-0 fw-bold">
                                                                {selectedVideo?.recordtime ? new Date(selectedVideo?.recordtime).toLocaleString() : 'N/A'}
                                                            </p>
                                                        </div>
                                                        <div className="card card-body p-2">
                                                            <strong className="text-muted d-block" style={{ fontSize: '12px' }}>Face Verified</strong>
                                                            <p className="mb-0">
                                                                <span className={`badge ${selectedVideo?.is_face_verified ? 'bg-success' : 'bg-danger'}`}>
                                                                    {selectedVideo?.is_face_verified ? 'Yes ✓' : 'No ✗'}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Eye Movement Statistics */}
                                                    {selectedVideo?.eye_movement_response && (
                                                        <div className="card card-body p-2">
                                                            <strong className="text-muted d-block" style={{ fontSize: '12px' }}>
                                                                <i className="fa fa-eye me-2"></i>
                                                                Eye Movement Analysis
                                                            </strong>
                                                            {(() => {
                                                                const stats = getEyeMovementStats(selectedVideo.eye_movement_response);
                                                                return (
                                                                    <div style={{ marginTop: '8px' }}>
                                                                        <p className="mb-2" style={{ fontSize: '12px' }}>
                                                                            <strong>Total Duration:</strong> {stats.duration}
                                                                        </p>
                                                                        {Object.keys(stats.breakdown).length > 0 && (
                                                                            <div style={{ marginTop: '8px' }}>
                                                                                <strong style={{ fontSize: '12px' }} className="d-block mb-2">Breakdown:</strong>
                                                                                {Object.entries(stats.breakdown).map(([movement, count], idx) => (
                                                                                    <div key={idx} className="card card-body p-2 mb-2" style={{ 
                                                                                        display: 'flex',
                                                                                        justifyContent: 'space-between',
                                                                                        fontSize: '12px'
                                                                                    }}>
                                                                                        <span>{movement}</span>
                                                                                        <span className="badge bg-label-primary"> 
                                                                                            {count}s ({((count / stats.total) * 100).toFixed(1)}%)
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="alert alert-info" role="alert">
                                        <i className="fa fa-info-circle me-2"></i>
                                        No videos available
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseVideoModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
